import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import {
  ProductOptionItem,
  StockDisplayCondition,
  SUPPORTED_LANGUAGES,
} from '@pedix-workspace/utils';

import { NgClass, AsyncPipe } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';
import { AvailableStockComponent, StockInfoPipe } from '@pedix-workspace/pedixapp-stock';
import { IconImageComponent } from '@pedix-workspace/angular-ui-icons';
import { PropInSelectedLanguagePipe } from '@pedix-workspace/pedixapp-shared-pipes';
import { ProductDetailItemPriceComponent } from '../../product-detail-item-price/product-detail-item-price.component';

type ProductOptionItemSelector = Pick<
  ProductOptionItem,
  'id' | 'name' | 'description' | 'price' | 'priceDiscount' | 'sku' | 'image'
>;

@Component({
    selector: 'pxw-product-option-item-radio',
    templateUrl: './product-option-item-radio.component.html',
    styleUrls: ['./product-option-item-radio.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        TranslocoDirective,
        NgClass,
        AsyncPipe,
        AvailableStockComponent,
        IconImageComponent,
        StockInfoPipe,
        PropInSelectedLanguagePipe,
        ProductDetailItemPriceComponent,
    ]
})
export class ProductOptionItemRadioComponent {
  readonly optionId = input.required<string>();
  readonly optionMin = input.required<number>();
  readonly item = input.required<ProductOptionItemSelector>();
  readonly cartItemId = input.required<string | undefined>();
  readonly displaySku = input.required<boolean>();
  readonly selectedLanguage = input.required<SUPPORTED_LANGUAGES | undefined>();
  readonly count = input.required<number>();
  readonly disableIncrement = input.required<boolean>();
  readonly displayItemQuantities = input.required<boolean>();
  readonly maxCount = input.required<number>();
  readonly displayProductPriceWithoutTaxes = input.required<boolean>();
  readonly stockDisplayCondition = input.required<StockDisplayCondition>();
  readonly stockDisplayConditionValue = input.required<number>();

  readonly itemImageClick = output<void>();

  onItemImageClick($event: Event) {
    $event.preventDefault();
    $event.stopImmediatePropagation();

    this.itemImageClick.emit();
  }
}
